import { Locale } from '../constants/languageHelpers'
import { Languages } from '../interfaces/common'

export const getLocale = (locale?: string) => {
  switch (locale) {
    case Locale.KZ:
      return Languages.KZ

    case Locale.UZ:
      return Languages.UZ

    default:
      return Languages.RU
  }
}
